module.exports = __webpack_public_path__ + "cfdc3b75daefa5a383bd3b51229497fa.pdf";